import { formatDate } from './modelHelpers';

class ActionTypeMapping {
  constructor(data) {
    Object.assign(this, data);
  }

  createdAtString() {
    return new Date(Date.parse(this.createdAt)).toDateString();
  }

  createdAtStringLong() {
    return formatDate(new Date(Date.parse(this.createdAt)));
  }

  updatedAtStringLong() {
    return formatDate(new Date(Date.parse(this.updatedAt)));
  }

  dup() {
    return new ActionTypeMapping(this);
  }
}

export default ActionTypeMapping;
